import React, { useEffect, useState } from "react";
import WebTopCategories from "src/Components/WebsiteComponents/WebTopCategories";
import { Link, useParams } from "react-router-dom";
import SplashScreen from "src/Components/SplashScreen";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import qs from "qs";
import { IPharmacyObj } from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import { getToken, truncateString } from "src/helpers/helperFunctions";
import { jwtDecode } from "jwt-decode";
import IsFavoriteComponent from "src/Components/Customer/ProductsAndServicesComponents/IsFavoriteComponent";
import AddCartComponent from "src/Components/Customer/ProductsAndServicesComponents/AddCartComponent";
import PaginationComponet from "src/Components/GlobalComponents/PaginationComponet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import RangeSlider from "src/Components/WebsiteComponents/RangeSlider";
import { CircularProgress } from "@mui/material";
import { CURRENCY } from "src/lib/constans";

interface IqueryParamsExtend {
  page: number;
  limit: number;
  userId: string;
  mainCategoryId: string[];
  subCategoryId: string[];
  childCategoryId: string[];
  brandId: string[];
  minPrice: number;
  maxPrice: number;
}

interface IProductResponse {
  documents: IPharmacyObj[];
  paginated: IPaginated;
}

interface IResponse {
  mainCategory: {
    mainCategoryDetails: {
      banner: string;
      image: string;
      name: string;
    };
    subCategoryDetails: {
      _id: string;
      banner: string;
      image: string;
      name: string;
    }[];
  }[];
  subCategory: {
    mainCategoryId: string;
    mainCategoryName: string;
    subCategory: {
      banner: string;
      image: string;
      name: string;
    };
    childCategories: {
      _id: string;
      banner: string;
      image: string;
      name: string;
    }[];
  }[];
  child: {
    _id: string;
    categoryBanner: string;
    childCategoryImage: string;
    childCategoryName: string;
    mainCategoryId: string;
    mainCategoryName: string;
    subCategoryId: string;
    subCategoryName: string;
  }[];
  brand: {
    _id: string;
    brandLogo: string;
    brandName: string;
    bannerImage: string;
    shortDescription: string;
  }[];
}

const WebPharmaCategory: React.FC = () => {
  const { category = "", id = "" } = useParams();

  const returnImageUrl = (): string => {
    return category === "brand"
      ? `${items?.brand[0]?.bannerImage || ""}`
      : category === "main-category"
      ? `${items?.mainCategory[0]?.mainCategoryDetails?.banner || ""}`
      : category === "sub-category"
      ? `${items?.subCategory[0]?.subCategory?.banner || ""}`
      : category === "child-category"
      ? `${items?.child[0]?.categoryBanner || ""}`
      : "";
  };
  const printName = (): string => {
    return category === "brand"
      ? items?.brand[0]?.brandName || ""
      : category === "main-category"
      ? `${items?.mainCategory[0]?.mainCategoryDetails?.name || ""}`
      : category === "sub-category"
      ? `${items?.subCategory[0]?.subCategory?.name || ""}`
      : category === "child-category"
      ? `${items?.child[0]?.childCategoryName || ""}`
      : "";
  };
  const printBreadCrumb = () => {
    return (
      <>
        {category === "main-category" ? (
          <div>
            <Link className="text-[#299E96]" to={"/pharmacy-products"}>
              Home
            </Link>{" "}
            {">"} {items?.mainCategory[0]?.mainCategoryDetails?.name || ""}
          </div>
        ) : category === "sub-category" ? (
          <div>
            <Link className="text-[#299E96]" to={"/pharmacy-products"}>
              Home
            </Link>{" "}
            {">"}
            <Link
              className="text-[#299E96]"
              to={`/pharmacy/main-category/${items?.subCategory[0]?.mainCategoryId}/view`}
            >
              {items?.subCategory[0]?.mainCategoryName}
            </Link>{" "}
            {">"}
            {items?.subCategory[0]?.subCategory?.name || ""}
          </div>
        ) : category === "child-category" ? (
          <div>
            <Link className="text-[#299E96]" to={"/pharmacy-products"}>
              Home
            </Link>{" "}
            {">"}
            <Link
              className="text-[#299E96]"
              to={`/pharmacy/main-category/${items?.child[0]?.mainCategoryId}/view`}
            >
              {items?.child[0]?.mainCategoryName}
            </Link>{" "}
            {">"}
            <Link
              className="text-[#299E96]"
              to={`/pharmacy/sub-category/${items?.child[0]?.subCategoryId}/view`}
            >
              {items?.child[0]?.subCategoryName}
            </Link>{" "}
            {">"}
            {items?.child[0]?.childCategoryName || ""}
          </div>
        ) : category === "brand" ? (
          <div>
            <Link className="text-[#299E96]" to={"/pharmacy-products"}>
              Home
            </Link>{" "}
            {">"} {items?.brand[0]?.brandName || ""}
          </div>
        ) : (
          ""
        )}
      </>
    );
  };
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [items, setItems] = useState<IResponse | null>(null);
  const fetch = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IResponse>({
      path: `/child-category/by-category/${id}`,
    });
    if (res) {
      setItems(res || null);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    if (id && category) {
      fetch();
      setQueryParams((prev) => ({
        ...prev,
        mainCategoryId: category === "main-category" ? [id] : [],
        subCategoryId: category === "sub-category" ? [id] : [],
        childCategoryId: category === "child-category" ? [id] : [],
        brandId: category === "brand" ? [id] : [],
      }));
    }
  }, [id, category]);

  const token = getToken() || "";
  let decoded: { id: string };
  if (token) {
    decoded = jwtDecode<{ id: string }>(token);
  } else {
    decoded = { id: "" };
  }
  const [productLoader, setProductLoader] = useState(false);
  const [products, setProducts] = useState<IPharmacyObj[]>([]);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  }); // Handles pagination state
  const [dropdown, setDropDown] = useState<{
    category: boolean;
    brand: boolean;
    price: boolean;
  }>({
    category: true,
    brand: true,
    price: true,
  });
  const toogleDropDown = (key: "category" | "price" | "brand") => {
    setDropDown((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  const [queryParams, setQueryParams] = useState<IqueryParamsExtend>({
    page: 1,
    limit: 20,
    userId: decoded.id,
    mainCategoryId: [],
    subCategoryId: [],
    childCategoryId: [],
    brandId: [],
    minPrice: 0,
    maxPrice: 10000,
  });
  const handlePriceChange = (val: number[]) => {
    setQueryParams((prev) => {
      return {
        ...prev,
        page: 1,
        minPrice: val[0],
        maxPrice: val[1],
      };
    });
  };
  const handleIsLikeChanged = (obj: {
    productId: string;
    isLiked: boolean;
  }) => {
    const { productId = "", isLiked = false } = obj;
    setProducts((prev) =>
      prev?.map((v) => (v._id === productId ? { ...v, isLiked } : v))
    );
  };
  const fetchProducts = async () => {
    setProductLoader(true);
    const { res, err } = await httpRequest<IProductResponse>({
      path: `/pharma-inventory/home/getPharmaProducts?${qs.stringify(
        queryParams
      )}`,
    });
    if (res) {
      let { documents = [], paginated } = res;
      setProducts(documents);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setProductLoader(false);
  };
  useEffect(() => {
    if (
      queryParams?.brandId?.length ||
      queryParams?.mainCategoryId?.length ||
      queryParams?.subCategoryId?.length ||
      queryParams?.childCategoryId?.length
    ) {
      fetchProducts();
    }
  }, [queryParams]);

  const [brandLoader, setBrandLoader] = useState<boolean>(false);
  const [allBrands, setAllBrands] = useState<
    { _id: string; brandName: string }[]
  >([]);
  const changeBrandFilter = (id: string) => {
    setQueryParams((prev) => ({
      ...prev,
      brandId: prev?.brandId?.includes(id)
        ? prev?.brandId?.filter((v) => v !== id)
        : [...prev?.brandId, id],
    }));
  };
  const fetchAllBrands = async () => {
    setBrandLoader(true);
    const { res, err } = await httpRequest<{
      documents: { _id: string; brandName: string }[];
    }>({ path: "/brand/home/getallbrands" });
    if (res) {
      setAllBrands(res?.documents || []);
    } else {
      toast(err, { type: "error" });
    }
    setBrandLoader(false);
  };
  useEffect(() => {
    fetchAllBrands();
  }, []);

  const SubCategory = () => {
    const arr = items?.mainCategory[0]?.subCategoryDetails || [];
    return arr?.length ? (
      <WebTopCategories
        category="sub-category"
        loader={isLoader}
        data={arr?.map((v) => ({
          images: v?.image,
          id: v?._id,
          name: v?.name,
        }))}
      />
    ) : null;
  };
  const ChildCategory = () => {
    const arr = items?.subCategory[0]?.childCategories || [];
    return arr?.length ? (
      <WebTopCategories
        category="child-category"
        loader={isLoader}
        data={arr?.map((v) => ({
          images: v?.image,
          id: v?._id,
          name: v?.name,
        }))}
      />
    ) : null;
  };

  const allCategories: { name: string; _id: string }[] =
    category === "main-category"
      ? items?.mainCategory[0]?.subCategoryDetails || []
      : category === "sub-category"
      ? items?.subCategory[0]?.childCategories || []
      : [];

  const PrintCategoryFilters: React.FC<{ id: string }> = ({ id = "" }) => {
    const isExist =
      category === "main-category"
        ? queryParams?.subCategoryId?.includes(id)
        : category === "sub-category"
        ? queryParams?.childCategoryId?.includes(id)
        : false;
    const handleChangeCategory = (id: string) => {
      if (category === "main-category") {
        setQueryParams((prev) => ({
          ...prev,
          page: 1,
          subCategoryId: isExist
            ? prev?.subCategoryId?.filter((v) => v !== id)
            : [...prev?.subCategoryId, id],
        }));
      } else if (category === "sub-category") {
        setQueryParams((prev) => ({
          ...prev,
          page: 1,
          childCategoryId: isExist
            ? prev?.childCategoryId?.filter((v) => v !== id)
            : [...prev?.childCategoryId, id],
        }));
      } else {
      }
    };
    return (
      <input
        checked={isExist}
        type="checkbox"
        id={id}
        onChange={() => handleChangeCategory(id)}
      />
    );
  };
  return (
    <>
      {productLoader && <SplashScreen />}
      {items && (
        <>
          <div className="pharmacy-banner child-categories-pharmacy-banner">
            <div className="container-1400">
              <span className="font-Poppins-Regular pt-4 block text-[#707070] font-size-16px">
                {printBreadCrumb()}
              </span>
              <div className="py-4 relative">
                <img
                  className="thumbnail-img-by-category"
                  src={returnImageUrl()}
                  alt=""
                />
                {category === "brand" && (
                  <img
                    className="h-[8vw] w-[8vw] absolute bottom-0 left-[2vw] z-10 rounded-lg"
                    src={`${items?.brand[0]?.brandLogo || ""}`}
                    alt=""
                  />
                )}
              </div>
              {category === "brand" && (
                <div className="mt-4 left-[2vw] relative">
                  <h4 className="font-Poppins-SemiBold  font-size-20px">
                    {items?.brand[0]?.brandName}
                  </h4>
                  <p className="font-Poppins-Regular font-size-16px">
                    {items?.brand[0]?.shortDescription}
                  </p>
                </div>
              )}
              {category === "main-category" && <SubCategory />}
              {category === "sub-category" && <ChildCategory />}
            </div>
          </div>
          <div className="bg-white py-4">
            <div className="container-1400">
              <div className="product-by-categories-main-grid">
                <div className="product-by-categories-left">
                  {(category === "main-category" ||
                    category === "sub-category") && (
                    <div>
                      <div
                        className={`${
                          dropdown.category
                            ? ""
                            : "product-by-categories-head-inner-open"
                        } product-by-categories-head-inner`}
                      >
                        <span className="font-Poppins-Medium text-white font-size-18px">
                          Categories ({allCategories?.length || 0})
                        </span>
                        <FontAwesomeIcon
                          className="font-size-18px cursor-pointer text-white"
                          icon={dropdown.category ? faChevronUp : faChevronDown}
                          onClick={() => toogleDropDown("category")}
                        />
                      </div>
                      {dropdown.category ? (
                        <div className="product-by-categories-padd">
                          {/* <div className="relative product-by-categories-search">
                                                        <FontAwesomeIcon
                                                            className="font-size-16px text-[#619B97]"
                                                            icon={faMagnifyingGlass}
                                                        />
                                                        <input
                                                            className="font-Poppins-Regular font-size-16px text-[#619B97]"
                                                            type="text"
                                                            placeholder="Search by Categories"
                                                        />
                                                    </div> */}
                          <div className="pt-3">
                            {isLoader && (
                              <div className="text-center">
                                <CircularProgress
                                  size={16}
                                  className="theme-color-green"
                                />
                              </div>
                            )}
                            {allCategories?.map((v) => (
                              <div
                                key={v?._id}
                                className="flex gap-3 items-center product-by-categories-checkbox"
                              >
                                <PrintCategoryFilters id={v?._id} />
                                <label
                                  className="font-Poppins-Medium text-[#707070] font-size-16px"
                                  htmlFor={v?._id}
                                >
                                  {v?.name}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  )}
                  <div>
                    <div
                      className={`${
                        dropdown.brand
                          ? ""
                          : "product-by-categories-head-inner-open"
                      } product-by-categories-head-inner`}
                    >
                      <span className="font-Poppins-Medium text-white font-size-18px">
                        Brands ({allBrands?.length || 0})
                      </span>
                      <FontAwesomeIcon
                        className="font-size-18px cursor-pointer text-white"
                        icon={dropdown.brand ? faChevronUp : faChevronDown}
                        onClick={() => toogleDropDown("brand")}
                      />
                    </div>
                    {dropdown.brand ? (
                      <div className="product-by-categories-padd">
                        <div className="pt-3">
                          {brandLoader && (
                            <div className="text-center">
                              <CircularProgress
                                size={16}
                                className="theme-color-green"
                              />
                            </div>
                          )}
                          {allBrands?.map((v) => (
                            <div
                              key={v?._id}
                              className="flex gap-3 items-center product-by-categories-checkbox"
                            >
                              <input
                                checked={queryParams?.brandId?.includes(v?._id)}
                                type="checkbox"
                                id={v?._id}
                                onChange={() => changeBrandFilter(v?._id)}
                              />
                              <label
                                className="font-Poppins-Medium text-[#707070] font-size-16px"
                                htmlFor={v?._id}
                              >
                                {v?.brandName}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <div
                      className={`${
                        dropdown.price
                          ? ""
                          : "product-by-categories-head-inner-open"
                      } product-by-categories-head-inner`}
                    >
                      <span className="font-Poppins-Medium text-white font-size-18px">
                        Price
                      </span>
                      <FontAwesomeIcon
                        className="font-size-18px cursor-pointer text-white"
                        icon={dropdown.price ? faChevronUp : faChevronDown}
                        onClick={() => toogleDropDown("price")}
                      />
                    </div>
                    {dropdown.price && (
                      <div className="p-6">
                        <div>
                          <RangeSlider
                            minRange={0}
                            maxRange={10000}
                            step={100}
                            currentRanges={[
                              queryParams?.minPrice,
                              queryParams?.maxPrice,
                            ]}
                            changePriceRanges={handlePriceChange}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="product-by-categories-right">
                  <span className="font-Poppins-Medium text-white product-by-categories-head-result font-size-18px">{`Results For ${printName()}`}</span>
                  <div className="result-for-health-care">
                    {products?.length
                      ? products.map((item) => (
                          <div key={item?._id} className="pharmacy-card-main">
                            <div className="Prescription-requird-main">
                              <div className="Prescription-requird">
                                {item?.prescriptionRequired ? (
                                  <span className="Prescription-requird-inner-span text-white font-Poppins-Regular font-size-12px">
                                    Prescription Required
                                  </span>
                                ) : (
                                  <span></span>
                                )}
                                <IsFavoriteComponent
                                  productId={item?._id}
                                  isFav={item?.isLiked || false}
                                  category="pharmacy"
                                  onSuccess={handleIsLikeChanged}
                                />
                              </div>
                            </div>
                            <div className="pharmacy-card-main-content-cls-inner">
                              <img
                                className="product-dummy-img"
                                src={`${item?.mainImage}`}
                                alt={""}
                              />
                            </div>
                            <div className="pharmacy-card-main-content-cls">
                              <Link to={`/pharmacy-products/${item?._id}/view`}>
                                <p className="font-size-14px font-Poppins-SemiBold pharmacy-card-main-span-title theme-color-green">
                                  {truncateString(item?.productName || "", 40)}
                                </p>
                              </Link>
                              <div className="flex product-item-card-price justify-between">
                                {/* <strong className='font-size-18px font-Poppins-Bold theme-color-green'>{`${CURRENCY} ${item?.regularPrice || "-"}`}</strong> */}
                                <div className="sale-price-or-regular-price">
                                  <strong className="font-size-18px font-Poppins-Bold theme-color-green">
                                    {CURRENCY}{" "}
                                    {item?.salePrice || item?.regularPrice}
                                  </strong>
                                  {item?.salePrice != null &&
                                    item?.salePrice > 0 && (
                                      <strong className="font-size-13px line-through font-Poppins-Regular text-[#878787]">
                                        {CURRENCY}{" "}
                                        {`${item?.regularPrice || "-"}`}
                                      </strong>
                                    )}
                                </div>
                                <AddCartComponent
                                  productId={item?._id}
                                  type="pharmacy"
                                  prescriptionRequired={
                                    item?.prescriptionRequired || false
                                  }
                                  quantity={1}
                                />
                              </div>
                            </div>
                          </div>
                        ))
                      : "No Product"}
                  </div>
                  <div className="pagination-padding-web">
                    <PaginationComponet
                      currentPage={paginated.currentPage || 1}
                      total={paginated.totalPages || 1}
                      setCurrentPage={(_page) =>
                        setQueryParams((prev) => ({ ...prev, page: _page }))
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default WebPharmaCategory;
